var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.693.18a.67.67 0 0 1 .033.945L10.302 6.96l5.987 7.97a.67.67 0 0 1-.533 1.07h-3.652a.66.66 0 0 1-.533-.265l-4.213-5.608-5.263 5.661a.67.67 0 0 1-.943.033.67.67 0 0 1-.033-.945l5.425-5.834-5.987-7.97a.67.67 0 0 1 .532-1.07h3.653a.67.67 0 0 1 .532.266l4.213 5.608L14.75.213a.667.667 0 0 1 .942-.033zM8.926 7.35a1 1 0 0 1-.052-.069L4.409 1.337H2.425l10.011 13.326h1.984z",
    clipRule: "evenodd"
  })));
};
export default SvgX;